import { render, staticRenderFns } from "./RsaConfigurazioneProfiliLisListPage.vue?vue&type=template&id=511bead7"
import script from "./RsaConfigurazioneProfiliLisListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneProfiliLisListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports